import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    standalone: false
})
export class DatepickerComponent implements OnInit {

  @Input()
  set controlName(value: string) {
    this.formControl = this.parentFormGroup.form.get(value) as FormControl;
  }

  @Input()
  set control(formControl: FormControl) {
    this.formControl = formControl;
  }

  @Input() placeholder: string;
  formControl: FormControl;

  constructor(private parentFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
  }

}
